import React from "react";
import { Text, View } from "react-native";
import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";
import NetworkManager from "../../contexts/NetworkManager";

const ComponentStory = () => {
    return (
        <NetworkManager>
            <VStack gap={0.5} alignment="stretch" style={{ width: "100%" }}>
                <Text style={{ fontSize: 40 }}>Internet is working!</Text>
                <Text style={{ fontSize: 14 }}>Disabled network to see the network lost panel</Text>
            </VStack>
        </NetworkManager>
    );
};

const meta = {
    title: "Components/NetworkManager",
    component: ComponentStory,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof ComponentStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
